module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.5cbf0bf.woff2";